<template>
    <li class="pp-picker-option" 
        :class="{'is-active': isActive}"
        @click.stop="click">
        <span class="pp-picker-option__label">{{label}}</span>
        <span class="pp-picker-option__icon">
            <i :class="isActive ? 'pp-icon-circularfill' : 'pp-icon-circular'"></i>
        </span>
    </li>
</template>

<script>
export default {
    name: 'pp-picker-option',
    inheritAttrs: false,
    inject: ['Picker'],
    props: {
        value: [String, Number, Object],
        label: [String, Number],
        valueKey: '', //value为object时
    },
    computed: {
        isActive: function() {
            return this.Picker.currentValue === this.value
        },
    },
    created: function() {
        this.Picker.childrenValue.push({ label: this.label, value: this.value })
    },
    methods: {
        click: function() {
            this.Picker.update(this.label, this.value, this.valueKey)
        },
    },
}
</script>
